import React, { useMemo } from 'react';
import { FontAttributes, GoogleFontSettings } from '@loyalty/shared-common/template-api-client';
import { getFontFace } from '@loyalty/editor-components';

export interface FontsLoaderProps {
  fonts: FontAttributes[];
}

export function FontsLoader({ fonts }: FontsLoaderProps) {
  const customFonts = useMemo(() => fonts.filter(({ type }) => type === 'custom'), [fonts]);
  const googleFonts = useMemo(() => fonts.filter(({ type }) => type === 'google'), [fonts]);

  return (
    <>
      <style>{customFonts.flatMap(getFontFace).join('\n')}</style>
      {googleFonts.map(font => (
        <link key={font.id} rel="stylesheet" href={(font.settings as GoogleFontSettings).link} />
      ))}
    </>
  );
}
